import { render, staticRenderFns } from "./RecommendBest.vue?vue&type=template&id=776d274a"
import script from "./RecommendBest.vue?vue&type=script&lang=js"
export * from "./RecommendBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports